import { useTranslation } from 'react-i18next'

import { ColorPicker, Text } from '@reveni-io/reveni-ui'

import CodeWidget from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/CodeWidget/CodeWidget'

import ProductOptions from './ProductOptions/ProductOptions'
import WidgetPreview from './WidgetPreview/WidgetPreview'
import * as Styles from './styles'

const TryOnWidgetConfiguration = ({
  backgroundColor,
  setBackgroundColor,
  textColor,
  setTextColor,
  buttonColor,
  setButtonColor,
  buttonHoverColor,
  setButtonHoverColor,
  productTaxonomyDisplay,
  setProductTaxonomyDisplay,
  productTaxonomyType,
  setProductTaxonomyType,
  productTaxonomyIds,
  setProductTaxonomyIds,
  productCategories,
  productCollections,
  previewProduct,
  scriptInfo,
  store,
  tryonMode,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        {t(
          'Añade nuestro widget de probador virtual a las páginas de producto de tu tienda y permite a tus clientes ver cómo les quedan los artículos antes de comprar.'
        )}
      </Text>
      <Styles.ColorsContainer>
        <Text type="titleS">{t('Colores del widget')}</Text>
        <Styles.ColorsPickerContainer>
          <ColorPicker
            onChange={setBackgroundColor}
            label={t('Color del fondo')}
            type="colorPreview"
            defaultColor={backgroundColor}
          />
          <ColorPicker
            onChange={setTextColor}
            label={t('Color del texto')}
            type="colorPreview"
            defaultColor={textColor}
          />
          <ColorPicker
            onChange={setButtonColor}
            label={t('Color del botón')}
            type="colorPreview"
            defaultColor={buttonColor}
          />
          <ColorPicker
            onChange={setButtonHoverColor}
            label={t('Color del botón hover')}
            type="colorPreview"
            defaultColor={buttonHoverColor}
          />
        </Styles.ColorsPickerContainer>
      </Styles.ColorsContainer>
      <ProductOptions
        productTaxonomyDisplay={productTaxonomyDisplay}
        setProductTaxonomyDisplay={setProductTaxonomyDisplay}
        productTaxonomyType={productTaxonomyType}
        setProductTaxonomyType={setProductTaxonomyType}
        productTaxonomyIds={productTaxonomyIds}
        setProductTaxonomyIds={setProductTaxonomyIds}
        productCategories={productCategories}
        productCollections={productCollections}
      />
      <WidgetPreview
        backgroundColor={backgroundColor}
        textColor={textColor}
        buttonColor={buttonColor}
        buttonHoverColor={buttonHoverColor}
        previewProduct={previewProduct}
        storeId={store?.id}
        tryonMode={tryonMode}
      />
      <CodeWidget store={store} scriptInfo={scriptInfo} />
    </Styles.Container>
  )
}

export default TryOnWidgetConfiguration
